import {
  initialState,
  Actions,
  State,
  DELETE_PAGO,
  DELETE_PAGO_SUCCESS,
  DELETE_PAGO_ERROR,
  RESET_DELETE_PAGO,
} from "../../types/pago/delete";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_PAGO:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case DELETE_PAGO_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case DELETE_PAGO_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      };
    case RESET_DELETE_PAGO:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
